<template>
  <section id="contacto" class="py-5 py-md-5 bg-white text-dark position-relative overflow-hidden">
    
    <div class="container py-4 position-relative z-index-1">
      
      <div class="row mb-5 text-center">
        <div class="col-lg-8 mx-auto animate__fadeInDown">
          <h2 class="display-5 fw-bold section-title-dark-shadow">
            Estamos Listos para Ayudarte
          </h2>
          <p class="lead text-secondary animate__delay-0s">
            Tu solución tecnológica a un mensaje de distancia.
          </p>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-8">
          <div class="contact-card-light p-4 p-md-5 animate__zoomIn animate__delay-1s">
            <h3 class="fw-bold mb-4 text-primary text-center">Envíanos un WhatsApp Rápido</h3>
            
            <form @submit.prevent="sendWhatsAppMessage">
              <div class="mb-4 animate__fadeInUp animate__delay-1-2s">
                <label for="nombre" class="form-label mb-2">Nombre Completo <span class="text-danger">*</span></label>
                <input 
                  type="text" 
                  class="form-control form-control-light-shadow" 
                  id="nombre" 
                  v-model="formData.nombre" 
                  placeholder="Ej: Juan Pérez" 
                  required
                >
              </div>

              <div class="mb-4 animate__fadeInUp animate__delay-1-4s">
                <label for="telefono" class="form-label mb-2">Teléfono (con código de país) <span class="text-danger">*</span></label>
                <input 
                  type="tel" 
                  class="form-control form-control-light-shadow" 
                  id="telefono" 
                  v-model="formData.telefono" 
                  placeholder="Ej: +584123659519" 
                  required
                >
              </div>

              <div class="mb-4 animate__fadeInUp animate__delay-1-6s">
                <label for="email" class="form-label mb-2">Correo Electrónico (Opcional)</label>
                <input 
                  type="email" 
                  class="form-control form-control-light-shadow" 
                  id="email" 
                  v-model="formData.email" 
                  placeholder="Ej: briantisman@gmail.com"
                >
              </div>

              <div class="mb-4 animate__fadeInUp animate__delay-1-8s">
                <label for="mensaje" class="form-label mb-2">¿Cómo podemos ayudarte? <span class="text-danger">*</span></label>
                <textarea 
                  class="form-control form-control-light-shadow" 
                  id="mensaje" 
                  rows="4" 
                  v-model="formData.mensaje" 
                  placeholder="Describe brevemente el problema o tu consulta..." 
                  required
                ></textarea>
              </div>

              <div class="d-grid gap-2 animate__bounceIn animate__delay-2s">
                <button type="submit" class="btn btn-whatsapp-submit btn-lg btn-shadow-intensive">
                  <i class="bi bi-whatsapp me-2"></i> Enviar Mensaje por WhatsApp
                </button>
              </div>
            </form>
            
            <p class="text-center text-muted-dark mt-4 animate__fadeInUp animate__delay-2-2s">
                *Al enviar, se abrirá tu aplicación de WhatsApp con el mensaje prellenado.
            </p>

          </div>
        </div>
      </div>

      <div class="row mt-5 pt-4 text-center justify-content-center">
        <div class="col-lg-10">
          <h3 class="fw-bold mb-4 text-dark animate__fadeInUp animate__delay-2-4s">Contáctanos Directamente</h3>
          <div class="d-flex justify-content-center gap-4 social-icons-light animate__fadeInUp animate__delay-2-6s">
            
            <a href="mailto:briantisman@gmail.com" class="social-icon-btn-light" title="briantisman@gmail.com">
                <i class="bi bi-envelope-fill"></i>
            </a>
            
            <a href="tel:+584123659519" class="social-icon-btn-light" title="+58 412-3659519">
                <i class="bi bi-telephone-fill"></i>
            </a>
            
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "ContacTanos",
  data() {
    return {
      formData: {
        nombre: '',
        telefono: '',
        email: '',
        mensaje: ''
      },
      // NÚMERO DE WHATSAPP REAL
      whatsappNumber: '584123659519' 
    };
  },
  methods: {
    sendWhatsAppMessage() {
      // Función para construir y enviar el mensaje a WhatsApp (sin cambios)
      const nombre = encodeURIComponent(this.formData.nombre);
      const telefono = encodeURIComponent(this.formData.telefono);
      const email = encodeURIComponent(this.formData.email || 'No proporcionado'); 
      const mensaje = encodeURIComponent(this.formData.mensaje);

      let fullMessage = `¡Hola Compuservicio!\n\n`;
      fullMessage += `Mi nombre es: *${nombre}*\n`;
      fullMessage += `Mi teléfono es: *${telefono}*\n`;
      fullMessage += `Mi correo es: *${email}*\n`;
      fullMessage += `\n*Mi consulta es:*\n${mensaje}\n\n`;
      fullMessage += `_Enviado desde el formulario de la web._`;

      const whatsappUrl = `https://api.whatsapp.com/send?phone=${this.whatsappNumber}&text=${encodeURIComponent(fullMessage)}`;
      
      window.open(whatsappUrl, '_blank');

      this.formData = {
        nombre: '',
        telefono: '',
        email: '',
        mensaje: ''
      };

      alert('Redirigiendo a WhatsApp con tu mensaje. ¡Gracias!');
    }
  }
};
</script>

<style scoped>
/* IMPORTANTE: Requiere Animate.css para las clases 'animate__' */

/* === Sección General y Fondo === */
.bg-white {
    background-color: #ffffff !important; 
    min-height: 90vh;
    display: flex;
    align-items: center;
}
.text-dark {
    color: #212529 !important;
}
.text-secondary {
    color: #5a5f64 !important;
}
.text-muted-dark {
    color: #777;
}

/* Título con Sombra Sutil */
.section-title-dark-shadow {
    color: #17171a;
    text-shadow: 1px 1px 5px rgba(13, 110, 253, 0.2); /* Sombra azul sutil */
}

/* === Tarjeta del Formulario (Glow Intensivo) === */
.contact-card-light {
    background: #ffffff; 
    border-radius: 20px;
    border: 2px solid #0d6efd; /* Borde azul definido */
    /* Sombra intensa que simula el glow azul sobre blanco */
    box-shadow: 0 10px 40px rgba(13, 110, 253, 0.4), 0 0 80px rgba(13, 110, 253, 0.1); 
    transition: all 0.5s cubic-bezier(0.25, 0.8, 0.25, 1);
    position: relative;
    z-index: 2;
}

.contact-card-light:hover {
    box-shadow: 0 15px 50px rgba(13, 110, 253, 0.6), 0 0 100px rgba(13, 110, 253, 0.2);
    transform: translateY(-8px) scale(1.01); /* Movimiento dramático */
}

/* === Campos del Formulario (Efecto Sombra/Borde) === */
.form-control-light-shadow {
    background-color: #f8f9fa; /* Fondo gris muy claro */
    border: 1px solid #ced4da;
    color: #212529;
    padding: 0.8rem 1rem;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
}

.form-control-light-shadow:focus {
    background-color: #ffffff;
    border-color: #0d6efd;
    box-shadow: 0 0 10px rgba(13, 110, 253, 0.6); /* Glow al enfocar */
    color: #212529;
    outline: none;
}

/* === Botón de Envío a WhatsApp (Sombra Intensa) === */
.btn-whatsapp-submit {
    background: #25D366;
    color: white;
    font-weight: 700;
    padding: 15px 30px;
    border-radius: 12px;
    transition: all 0.4s ease-in-out;
    border: none;
    font-size: 1.2rem;
}

.btn-shadow-intensive {
    box-shadow: 0 5px 25px rgba(37, 211, 102, 0.9); /* Sombra intensa en verde */
}

.btn-whatsapp-submit:hover {
    background: #1ebe5d;
    transform: translateY(-5px) scale(1.03);
    box-shadow: 0 10px 30px rgba(37, 211, 102, 1.5); /* Sombra más grande en hover */
}

/* === Íconos de Redes Sociales (Efecto de Sombra y Borde) === */
.social-icons-light {
  margin-top: 3rem;
}
.social-icon-btn-light {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f8f9fa;
    color: #0d6efd;
    font-size: 1.8rem;
    transition: all 0.3s ease-in-out;
    border: 1px solid #0d6efd;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.social-icon-btn-light:hover {
    background-color: #0d6efd;
    color: white;
    transform: translateY(-5px) scale(1.1);
    box-shadow: 0 10px 20px rgba(13, 110, 253, 0.5);
}

/* === Animaciones de Entrada (Retardos Ajustados) === */
.animate__delay-0s { animation-delay: 0.0s; } 
.animate__delay-1s { animation-delay: 0.3s; } 
.animate__delay-1-2s { animation-delay: 0.5s; } 
.animate__delay-1-4s { animation-delay: 0.7s; } 
.animate__delay-1-6s { animation-delay: 0.9s; } 
.animate__delay-1-8s { animation-delay: 1.1s; } 
.animate__delay-2s { animation-delay: 1.4s; } 
.animate__delay-2-2s { animation-delay: 1.7s; } 
.animate__delay-2-4s { animation-delay: 2.0s; } 
.animate__delay-2-6s { animation-delay: 2.3s; } 

.animate__fadeInDown, .animate__zoomIn, .animate__fadeInUp, .animate__bounceIn {
    animation-duration: 0.8s;
    animation-fill-mode: both;
}

/* === Responsive para Móviles === */
@media (max-width: 767.98px) {
  .section-title-dark-shadow {
    font-size: 2.2rem;
  }
  .contact-card-light {
    padding: 1.5rem;
  }
  .btn-whatsapp-submit {
    font-size: 1rem;
    padding: 12px 20px;
  }
  .social-icon-btn-light {
    width: 50px;
    height: 50px;
    font-size: 1.5rem;
  }
}
</style>